import { forwardRef, useEffect, useImperativeHandle } from "react";
import { Button, Col, Form, Input, Row, Tooltip, Select } from "antd";
import { DASHBOARD_LOTTOS } from "../../../../../constants/AppConstants";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";

const { Option } = Select;

const LottoAwards = forwardRef((props, ref) => {
  const { visible, data, onUpdate, isEdit } = props;
  const [form] = Form.useForm();


  useImperativeHandle(ref, () => ({
    validate: () => form.validateFields(),
    getValues: () => form.getFieldsValue(),
  }));


  useEffect(() => {
    if (visible) {
      if (isEdit && data) {
        const initVal = { ...data };
        form.setFieldsValue(initVal);
      } else if (!data) {
        form.resetFields();
      }
    } else {
      form.resetFields();
    }
  }, [visible, data, isEdit, form]);


  const handleChange = () => {
    const values = form.getFieldsValue();
    onUpdate({ ...values });
  };


  return (
    <Form
      form={form}
      layout="vertical"
      onValuesChange={handleChange}
      initialValues={{ awards: data.awards }}
    >
      <Form.List name="awards">
        {(fields, { add, remove }) => (
          <>
            {fields.map(({ key, name, ...restField }) => (
              <Row key={key} gutter={16}>
                <Col className="px-5" xs={24} sm={12} md={7}>
                  <Form.Item
                    {...restField}
                    label={DASHBOARD_LOTTOS.AWARDS.COLUMNS.ID}
                    name={[name, "awardId"]}
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col className="px-5" xs={24} sm={12} md={8}>
                  <Form.Item
                    {...restField}
                    label={DASHBOARD_LOTTOS.AWARDS.COLUMNS.AWARD}
                    name={[name, "award"]}
                    rules={[{ required: true, message: "Premio requerido" }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col className="px-5" xs={24} sm={12} md={4}>
                  <Form.Item
                    {...restField}
                    label={DASHBOARD_LOTTOS.AWARDS.COLUMNS.PLACE}
                    name={[name, "place"]}
                    rules={[
                      { required: true, message: "Lugar/Posición requerida" },
                    ]}
                  >
                    <Select>
                      <Option value="1ER LUGAR">1ER LUGAR</Option>
                      <Option value="2DO LUGAR">2DO LUGAR</Option>
                      <Option value="3ER LUGAR">3ER LUGAR</Option>
                      <Option value="4TO LUGAR">4TO LUGAR</Option>
                      <Option value="5TO LUGAR">5TO LUGAR</Option>
                      <Option value="6TO LUGAR">6TO LUGAR</Option>
                      <Option value="7MO LUGAR">7MO LUGAR</Option>
                      <Option value="8VO LUGAR">8VO LUGAR</Option>
                      <Option value="9NO LUGAR">9NO LUGAR</Option>
                      <Option value="10MO LUGAR">10MO LUGAR</Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col className="px-5" xs={24} sm={12} md={4}>
                  <Form.Item
                    {...restField}
                    label={DASHBOARD_LOTTOS.AWARDS.COLUMNS.PLACE_NUMBER}
                    name={[name, "placeNumber"]}
                    rules={[
                      { required: true, message: "Num. Lugar requerido" },
                    ]}
                  >
                    <Select>
                      <Option value="1">1</Option>
                      <Option value="2">2</Option>
                      <Option value="3">3</Option>
                      <Option value="4">4</Option>
                      <Option value="5">5</Option>
                      <Option value="6">6</Option>
                      <Option value="7">7</Option>
                      <Option value="8">8</Option>
                      <Option value="9">9</Option>
                      <Option value="10">10</Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col
                  className="px-5"
                  xs={24}
                  sm={12}
                  md={1}
                  style={{ alignContent: "center", textAlign: "center" }}
                >
                  <Tooltip title={DASHBOARD_LOTTOS.AWARDS.ACTIONS.DELETE}>
                    <Button
                      shape="circle"
                      icon={<DeleteOutlined />}
                      type="primary"
                      danger
                      onClick={() => {
                        remove(name);
                      }}
                    />
                  </Tooltip>
                </Col>
              </Row>
            ))}

            <Button
              type="dashed"
              onClick={() => add()}
              block
              icon={<PlusOutlined />}
            >
              {DASHBOARD_LOTTOS.AWARDS.ACTIONS.ADD}
            </Button>
          </>
        )}
      </Form.List>
    </Form>
  );
});

export default LottoAwards;
